export default __webpack_public_path__ + "static/media/Benton-Sans-Medium.7923b7db.otf";